import { styled } from '@mui/material/styles';

export const Detail = styled('p')(({ theme, small }) => ({
  margin: 0,
  marginBottom: theme.spacing(2),
  ...(small && { fontSize: theme.fontSize.xsmall }),
  '& em': {
    fontStyle: 'normal'
  }
}));
